export default __webpack_public_path__ + "static/homeBanner-8438e22ebf85900e27156e78adc80a84.png";